import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

import { RestrictionsButtonPlaceholder } from './RestrictionsButtonPlaceholder.tsx';
import { RestrictionsButtonLoading } from './RestrictionsButtonLoading.tsx';

export const RestrictionsButtonLoaderPaint: LoadableType<{
	className?: string;
	contentId?: string;
	onClick(): void;
	resetDialogState?(): void;
	isDisabled?: boolean;
	restrictionsButtonSSRRendered?: boolean;
	restrictionsButtonSSRLocation?: string;
	triggeredFrom?: string;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictionsButton" */ './RestrictionsButton.tsx'))
			.RestrictionsButton,
	loading: RestrictionsButtonLoading,
});

export const RestrictionsButtonLoaderAfterPaint: LoadableType<{
	className?: string;
	contentId?: string;
	onClick(): void;
	resetDialogState?(): void;
	isDisabled?: boolean;
	restrictionsButtonSSRRendered?: boolean;
	restrictionsButtonSSRLocation?: string;
	triggeredFrom?: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RestrictionsButton" */ './RestrictionsButton.tsx'))
			.RestrictionsButton,
	loading: RestrictionsButtonPlaceholder,
});
